import { useMemo } from "react";
import type { components } from "../../apis/gen";
import {
	determineEventState,
	type EventStateValue,
} from "../../utils/event-state";

type Event = components["schemas"]["Event"];

export type { EventStateValue } from "../../utils/event-state";
// Re-export for components that import from here
export { EVENT_STATES, formatCountdown } from "../../utils/event-state";

interface UseEventStateResult {
	eventState: EventStateValue;
	countdown: number;
	isActiveState: boolean;
	isWaitingState: boolean;
	isEndgameState: boolean;
	isPlayingState: boolean;
	isEventEnded: boolean;
	hasNextSession: boolean;
	canAddSession: boolean;
	requiresCheckIn: boolean;
}

/**
 * Custom hook for managing event state based on timestamps.
 * This is a thin wrapper around the unified determineEventState utility.
 */
export const useEventState = (
	event: Event | undefined | null,
	currentTime: Date,
): UseEventStateResult => {
	const stateResult = useMemo(() => {
		return determineEventState(event, currentTime.getTime());
	}, [event, currentTime]);

	return {
		eventState: stateResult.state,
		countdown: stateResult.countdown,
		isActiveState: stateResult.isActiveState,
		isWaitingState: stateResult.isWaitingState,
		isEndgameState: stateResult.isEndgameState,
		isPlayingState: stateResult.isPlayingState,
		isEventEnded: stateResult.isEventEnded,
		hasNextSession: stateResult.hasNextSession,
		canAddSession: stateResult.canAddSession,
		requiresCheckIn: stateResult.requiresCheckIn,
	};
};
